import { createSelector, createStructuredSelector } from 'reselect';
import _ from 'lodash';

export const configuration = (state) => state.configuration;

export const supportPhoneSelector = createSelector(configuration, (conf) =>
  _.get(conf, 'support_info.phones[0]', '')
);

export const supportEmailSelector = createSelector(configuration, (conf) =>
  _.get(conf, 'support_info.email', '')
);

export const genres = createSelector(configuration, (conf) => _.get(conf, 'genres', []));

export const languages = createSelector(configuration, (conf) => _.get(conf, 'languages', []));

export const language = createSelector(configuration, (conf) => _.get(conf, 'language', 'ru'));

export const countryPhoneCode = createSelector(configuration, (conf) =>
  _.get(conf, 'country_phone_code', '')
);

export const socials = createSelector(configuration, (conf) => _.get(conf, 'socials', []));

export const geoSelector = createSelector(configuration, (conf) => _.get(conf, 'geo', ''));

export const partnerIdSelector = createSelector(configuration, (conf) =>
  _.get(conf, 'partner_id', null)
);

export const isEmbedPaySelector = createSelector(configuration, (conf) =>
  _.get(conf, 'embed_pay_enabled', true)
);

export const apiKeySelector = createSelector(configuration, (conf) => _.get(conf, 'api_key', ''));

export const getWatermarkSrc = createSelector(configuration, (conf) =>
  _.get(conf, 'watermark', '')
);

export const isWatermarkClickableEnabled = createSelector(configuration, (conf) =>
  _.get(conf, 'watermark_clickable_enabled', false)
);

const domains = {
  byGeo(geo) {
    return {
      ru: 'https://megogo.ru',
      ww: 'https://new.megogo.net',
      eu: 'https://new.megogo.net',
    }[geo];
  },
  byDefault: 'https://megogo.net',
};

export const publicDomain = createSelector(geoSelector, (geo) => domains.byGeo(geo) || domains.byDefault);

export default createStructuredSelector({
  configuration,
  languages,
  language,
  genres,
  countryPhoneCode,
  supportEmailSelector,
  supportPhoneSelector,
  geoSelector,
  partnerIdSelector,
  isEmbedPaySelector,
  apiKeySelector,
  getWatermarkSrc,
  isWatermarkClickableEnabled,
  publicDomain,
});
